import { matchPath } from 'react-router';
import { useLocation, Link } from 'react-router-dom';

import { TabList, Tabs, Tab } from '@frontend/components';

import { useTabsMeetingRequirements } from './hooks';

const ConfigurePageNavTabs = () => {
  const { pathname } = useLocation();
  const tabs = useTabsMeetingRequirements();

  const activeTabIndex = tabs.findIndex(
    ({ to }) => matchPath(to, pathname)?.isExact ?? false,
  );

  return (
    <Tabs index={activeTabIndex} flexShrink={0} orientation="vertical">
      <TabList maxWidth="10em" overflowX="clip" minWidth="none" gap={0} py={4}>
        {tabs.map((tabData) => {
          const Icon = tabData.icon;
          return (
            <Tab
              as={Link}
              to={tabData.to}
              key={tabData.to}
              isDisabled={tabData.isDisabled}
              py={1}
              m={0}
              minWidth="none"
              alignItems="start"
            >
              {Icon && <Icon boxSize={3} />}
              {tabData.name}
            </Tab>
          );
        })}
      </TabList>
    </Tabs>
  );
};

export default ConfigurePageNavTabs;
